module.exports = __webpack_public_path__ + "static/img/twjd-sdo13.cf2ae9e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdo13.png
// module id = 855
// module chunks = 0